import React from "react";
import { Button } from "@mui/material";
import { CheckCircle, AlertTriangle } from "lucide-react";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";

export const A11yStatusBadge = ({
  issueCount = 0,
  criticalCount = 0,
  warningCount = 0,
  onClick,
}) => {
  const t = useScrollytellTranslation();
  const isPassing = issueCount === 0;

  const rawText = t("a11yStatusBadge.issueCountLabel", "Tilgjengelighet: {{count}} merknader", {
    count: issueCount,
  });
  const badgeText = rawText.includes(String(issueCount))
    ? rawText
    : rawText.replace(/\d+/, String(issueCount));

  return (
    <Button
      type="button"
      variant="contained"
      onClick={onClick}
      sx={{
        width: "100%",
        borderRadius: "6px",
        padding: "6px 10px",
        margin: 0,
        justifyContent: "flex-start",
        fontSize: "12px",
        fontWeight: 600,
        textTransform: "none",
        backgroundColor: isPassing ? "#2E7D32" : "#ED6C02",
        color: "#FFFFFF",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        "&:hover": {
          backgroundColor: isPassing ? "#1B5E20" : "#C75C00",
        },
      }}
    >
      {isPassing ? (
        <>
          <CheckCircle size={16} />
          <span>{t("a11yStatusBadge.ok", "Universell utforming: OK (UU: OK)")}</span>
        </>
      ) : (
        <>
          <AlertTriangle size={16} />
          <span>{badgeText}</span>
        </>
      )}
    </Button>
  );
};
